import { Box, Skeleton, Stack } from '@mui/material';

import { useCosInfo, VerifyData } from '@/controllers/gridManager/accountsManager/accountManager';
import { submitDeleteAccountFollower } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import classNames from 'classnames/bind';
import { DataOnParents, KeyDataParents } from '../RegisterFollower/RegisterFollower';
import styles from './Step1.scss';

import TransAuth, { AuthComponentRef } from '@/views/components/componentsUI/TransAuth';
import ButtonElement from '@/views/elements/button/ButtonElement';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useRef, useState } from 'react';
import { setStateLoadingAction } from '@/stores/dataManager/Actions/appAction';
import { useTranslation } from 'react-i18next';
import ToastUtil from '@/views/components/Toast/Toast';
import { validateCode } from '@/utilities';
import useValidateCode from '@/componentShare/hooks/useValidateCode';
const cx = classNames.bind(styles);

export type PropsStep = {
    close: () => void,
    back: () => void,
    next: () => void,
    handleSaveDataOnParents: (key: KeyDataParents, data: {}) => void
    dataOnParents: DataOnParents,
    data: any
}

export type RadioStopCopy = "TRANS" | "SELL"


const Step1 = ({ close, back, next, handleSaveDataOnParents, dataOnParents, data }: PropsStep) => {
    const { t } = useTranslation()
    const { cosInfo } = useCosInfo()
    const { refaccount } = cosInfo
    const refAuth = useRef<AuthComponentRef>(null)
    const [code, setCode] = useState<string>('')
    const { Step1, dataVerify }: { Step1: any, dataVerify: VerifyData } = dataOnParents
    const { loading, isHasStocks } = Step1

    const handleNext = async () => {
        if (validateCode(code) === false) {
            ToastUtil.error(t('copytrade.common.noEmpty'))
            return
        }

        if (refAuth.current) {
            refAuth.current.processAuth()
        }
    }

    const processUnRegisterFollower = async (dataVerify: any) => {
        setStateLoadingAction(true)
        await submitDeleteAccountFollower({ accountId: refaccount, dataVerify }).then((rs) => {
            setStateLoadingAction(false)
            if (rs.isSuccess === true) {
                next()
            }
        })
    }

    const isValidCode = useValidateCode(code)

    return (
        <Box className="Step1" sx={{ height: "auto", overflow: 'auto' }}>
            <Stack
                direction={"column"}
                spacing={2}
            >
                <TypographyElement ColorElement="secondary" FontWeightElement={400} FontSizeElement='16px'>
                    {loading &&
                        <>
                            <Skeleton variant="text" sx={{ fontSize: '20px' }} />
                            <Skeleton variant="text" sx={{ fontSize: '20px' }} />
                        </>}
                    {loading === false && (isHasStocks === true ? t("copytrade.deleteFollower.warnHasStocks") :
                        t("copytrade.deleteFollower.warn")
                    )}
                </TypographyElement>

                <Box>
                    {dataVerify?.transactionId && <TransAuth
                        ref={refAuth}
                        verified={dataVerify?.verified ?? false}
                        listAuthType={dataVerify?.authtypes ?? []}
                        defaultAuthType={dataVerify?.authtype}
                        transactionId={dataVerify?.transactionId}
                        tokenId={dataVerify?.tokenid}
                        setLoadStatus={setStateLoadingAction}
                        doProcessData={{}}
                        twoFactorAuthFunc={processUnRegisterFollower}
                        noButton={true}
                        onAuthCodeChange={(e: string) => setCode(e)}
                    />}
                </Box>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement customType="Secondary" className={cx("btn-register")} variant="contained"
                        onClick={() => close()} > {t("copytrade.common.back")}</ButtonElement>
                    <ButtonElement customType="Primary" className={cx("btn-register")} variant="contained"
                        disabled={!isValidCode}
                        onClick={
                            () => handleNext()
                        } >{t("copytrade.common.confirm")}</ButtonElement>
                </Stack>
            </Stack>
        </Box >
    )
}

export default Step1